import { prop } from '@solta/ramda-extra'

import { securityAdapter } from './module'

const selectSecurities = prop('securities')

export const { selectAll: selectAllSecurities } = securityAdapter.getSelectors(
  selectSecurities
)
